var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            stroke: _vm.color,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            fill: "none"
          }
        },
        [
          _c("path", { attrs: { d: "M12 8V4H8" } }),
          _c("rect", {
            attrs: {
              x: "4",
              y: "8",
              width: "16",
              height: "12",
              rx: "2",
              fill: "none"
            }
          }),
          _c("path", { attrs: { d: "M2 14H4" } }),
          _c("path", { attrs: { d: "M20 14H22" } }),
          _c("path", { attrs: { d: "M9 13V15" } }),
          _c("path", { attrs: { d: "M15 13V15" } })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }